export const URL_FRANCE_COMPETENCES = 'https://francecompetences.fr';
export const URL_FRANCE_COMPETENCES_RECHERCHE = `${URL_FRANCE_COMPETENCES}/recherche/rncp/`;
